export type OrderTrackingMessages = {
  // Titles
  orderTrackingTitle: string;

  // Labels
  orderReceivedLabel: string;
  orderPaidLabel: string;
  orderHandlingLabel: string;
  orderInvoicedLabel: string;
  orderTransmittedToCourierLabel: string;
  orderShippedLabel: string;
  orderDeliveredLabel: string;
  orderCancelledLabel: string;
  orderWaitingLabel: string;
  orderErrorLabel: string;
  orderDraftLabel: string;
  orderCancellationRequestLabel: string;
};

export const ORDER_TRACKING_MESSAGES: OrderTrackingMessages = {
  // Titles
  orderTrackingTitle: "Rastreio do Pedido",

  // Labels
  orderReceivedLabel: "Aguardando Pagamento ",
  orderPaidLabel: "Pedido pago",
  orderHandlingLabel: "Em manuseio",
  orderInvoicedLabel: "Pedido faturado",
  orderTransmittedToCourierLabel: "Pedido transmitido para transportadora",
  orderShippedLabel: "Pedido enviado",
  orderDeliveredLabel: "Pedido entregue",
  orderCancelledLabel: "Pedido cancelado",
  orderWaitingLabel: "Orçamento",
  orderErrorLabel: "Erro no pedido",
  orderDraftLabel: "Rascunho",
  orderCancellationRequestLabel: "Pedido de Cancelamento",
};
